module.exports = __webpack_public_path__ + "img/23_75.bd054f4b.png";